import { post } from 'pc-sales/utils/http';

export const verifyMfa = async (mfaCode: string): Promise<{ expireAt: number }> =>
    await post('/auth/mfa-verification', { mfaCode });
